import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2160. 発注ダッシュボード（月次分析）
 * [GET] /workspaces/:identifier/purchase_dashboard/monthly_analysis
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  payment_context_ids?: number[];
};

export type PurchaseDashboardMonthlyAnalysis = {
  target_year_month: number[];
  ordering_budget_cumulative_amounts: number[];
  preparing_cumulative_amounts: number[];
  contracting_cumulative_amounts: number[];
  completed_cumulative_amounts: number[];
  ordering_budget_amounts: number[];
  preparing_amounts: number[];
  contracting_amounts: number[];
  completed_amounts: number[];
  purchase_order_phase_labels: {
    preparing: string;
    contracting: string;
    completed: string;
    stopped: string;
  };
};

const purchaseDashboardMonthlyAnalysis = (props: Props): Promise<PurchaseDashboardMonthlyAnalysis> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_dashboard/monthly_analysis`, { params: props });
};

export const usePurchaseDashboardMonthlyAnalysis = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_dashboard', 'monthly_analysis', { ...props }],
    queryFn: () => purchaseDashboardMonthlyAnalysis(props),
    staleTime: 1000 * 60 * 30,
  });
};
